import React, { useEffect, useState } from "react";
import { Globals } from "@react-spring/web";
import { useReducedMotion } from "./utils/useReducedMotion";
import { useInView } from "react-intersection-observer";

import { CardSlider } from "./components/cardSlider/CardSlider";
import { CarbonTemp } from "./components/charts/CarbonTemp";
import { HeatRain } from "./components/charts/HeatRain";
import { EnergyMix } from "./components/charts/EnergyMix";
import { ClimateAction } from "./components/charts/ClimateAction";
import { ArcticSeaLevel } from "./components/charts/ArcticSeaLevel";

import { GlobalStyle } from "./styles.App";

export default function App() {
  const prefersReducedMotion = useReducedMotion();
  const [isInViewRef, isInView] = useInView({ threshold: 1 });
  const [isAnimated, setIsAnimated]  = useState(false);

  // Disable animations for users which prefer reduced motion 
  useEffect(() => {
    Globals.assign({
      skipAnimation: prefersReducedMotion,
    });
  }, [prefersReducedMotion]);

  // Trigger animations only once
  useEffect(() => {
    if (isInView) {
      setIsAnimated(true);
    }
  }, [isInView]);

  return (
    <>
      <GlobalStyle />
      {/* <Title>Klimazahlen</Title> */}
      <div ref={isInViewRef}>
        <CardSlider>
          <CarbonTemp id="co2-temp-chart" isAnimated={isAnimated} />
          <HeatRain id="heat-rain-chart" isAnimated={isAnimated} />
          <EnergyMix id="energy-mix-chart" isAnimated={isAnimated} />
          <ArcticSeaLevel id="arctic-sea-level-chart" isAnimated={isAnimated} />
          <ClimateAction id="climate-action-chart" isAnimated={isAnimated} />
        </CardSlider>
      </div>
    </>
  );
}
